module.exports = __webpack_public_path__ + "static/img/郑静.dced811.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lbtuimaj/郑静.jpg
// module id = i4QF
// module chunks = 1